import { CSSProperties } from 'react'

export const breadcrumbs = {
  margin: '16px 0'
}

export const breadcrumbItem: CSSProperties = {
  cursor: 'pointer'
}
